export default "__VITE_ASSET__8tIj9Qb7__"